import { create } from 'zustand';
export const useSlippageStore = create()((set) => ({
    slippage: undefined,
    autoSlippage: true,
    setSlippage: (value) => set({ slippage: value }),
    setAutoSlippage: (value) => set({ autoSlippage: value }),
    clearSlippage: () => set({ slippage: undefined, autoSlippage: true })
}));
